module.exports = __webpack_public_path__ + "static/images/announcement.a1094acc9384032323dcb4ba1d70b57b.svg";